module.exports = __webpack_public_path__ + "static/media/sm.fd89ff29.webp";